import axios from "axios"
export default {
	namespaced: true,
	state: {
		breadcrumb: [],
		deleting: false,
		restoring: false
	},
	getters: {
		breadcrumb: state => state.breadcrumb,
		deleting: state => state.deleting,
		restoring: state => state.restoring
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		}
	}
}
